class Modal {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.isVisible = false;
    this.bindUI();
    this.ui.$modal.removeAttribute('style'); // to hide modal on page load then remove inline style
    this.bindEvents();
  }

  unmount() {
    this.ui.$sections.forEach((section) => {
      section.removeEventListener('click', this.toggle.bind(this));
    });

    this.ui.$close.removeEventListener('click', this.toggle.bind(this));
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$sections = [...this.element.querySelectorAll('[data-element="modal-trigger"]')];
    this.ui.$modal = document.querySelector('[data-ref="modal"]');

    // modal elements
    this.ui.$close = this.ui.$modal.querySelector('[data-ref="modal-close"]');
    this.ui.$title = this.ui.$modal.querySelector('[data-ref="modal-title"]');
    this.ui.$excerpt = this.ui.$modal.querySelector('[data-ref="modal-excerpt"]');
    this.ui.$infos = this.ui.$modal.querySelector('[data-ref="modal-infos"]');
    this.ui.$image = this.ui.$modal.querySelector('[data-ref="[modal-image]"]');
  }

  bindEvents() {
    this.ui.$sections.forEach((section) => {
      section.addEventListener('click', this.toggle.bind(this));
    });

    this.ui.$close.addEventListener('click', this.toggle.bind(this));
  }

  toggle(e) {
    const target = e.currentTarget.closest('[data-ref="people-item"]');

    if (this.isVisible) {
      this.isVisible = false;
      this.hideModal();
      this.removeContent();
    } else {
      this.isVisible = true;
      this.updateContent(target);
      this.showModal();
    }
  }

  updateContent(target) {
    if (target != null) {
      const title = target.getAttribute('data-title');
      const excerpt = target.getAttribute('data-excerpt');
      const infos = target.getAttribute('data-infos');
      const image = target.getAttribute('data-image');

      this.ui.$title.innerHTML = title;
      this.ui.$excerpt.innerHTML = excerpt;
      this.ui.$infos.innerHTML = infos;
      this.ui.$image.innerHTML = `<img src="${image}" alt="${title}" loading="lazy" />`;
    }
  }

  removeContent() {
    this.ui.$title.innerHTML = '';
    this.ui.$excerpt.innerHTML = '';
    this.ui.$infos.innerHTML = '';
    this.ui.$image.innerHTML = '';
  }

  showModal() {
    this.ui.$modal.classList.add('people-bio--visible');
    this.ui.$modal.setAttribute('aria-hidden', false);
    document.body.style.overflow = 'hidden';
  }

  hideModal() {
    this.ui.$modal.classList.remove('people-bio--visible');
    this.ui.$modal.setAttribute('aria-hidden', true);
    document.body.style.overflow = 'inherit';
  }
}

export default Modal;
